import * as swcHelpers from '@swc/helpers';
import { fromStoreByIdQueryToStore } from '../adapters/from-store-by-id-query-to-store.js';
import '../queries/get-book-appointment-type.js';
import '../queries/get-book-appointment-store.js';
import { GET_BOOK_APPOINTMENT_STORE_BY_ID } from '../queries/get-book-appointment-store-by-id.js';

/**
 * @description
 * Fetches a store by its globalStoreId and returns the store data.
 * If the globalStoreId is not provided, it returns null.
 */ const getBookAppointmentStore = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, globalStoreId, locale, isTryInStoreFlowEnabled, isGroupIdEnabled) {
        if (globalStoreId === undefined) {
            return null;
        }
        try {
            const { data , error  } = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_BOOK_APPOINTMENT_STORE_BY_ID,
                variables: {
                    globalStoreId
                }
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            const storeQueryData = data === null || data === void 0 ? void 0 : data.store;
            const storeData = fromStoreByIdQueryToStore(storeQueryData, [
                {
                    tryInStore: isTryInStoreFlowEnabled,
                    groupId: isGroupIdEnabled
                }, 
            ]);
            if (error) {
                console.error(error);
            }
            return storeData;
        } catch (error) {
            console.error(error);
            return null;
        }
    });
    return function getBookAppointmentStore(apolloClient, globalStoreId, locale, isTryInStoreFlowEnabled, isGroupIdEnabled) {
        return _ref.apply(this, arguments);
    };
}();

export { getBookAppointmentStore };
//# sourceMappingURL=book-appointment-store-by-id.js.map
